import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  FaSearch,
  FaEdit,
  FaTrash,
  FaEye,
  FaChartLine,
  FaCog,
  FaPlus,
  FaChartBar,
  FaLightbulb,
  FaBullseye,
} from "react-icons/fa";
import {
  MdCampaign,
  MdVisibility,
  MdCardGiftcard,
  MdTrendingUp,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import moment from "moment/moment";
import Loader from "../../Loader/Loader"; // adjust the path
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { showToast } from "../../../Helper/Toast";
import { hitGetServiceProfessionalApi } from "../../../Redux/Professional/GetServiceSlice";
import { hitPromotionListProfessionalApi } from "../../../Redux/Professional/PromotionListSlice";
import { hitPromotionUpdateApi } from "../../../Redux/Professional/UpdatePromotionSlice";
import tick from "../../../assets/img/tick_active.svg";
import ActiveCampaigns from "../../../assets/img/Active Campaigns.svg";
import OffersViewed from "../../../assets/img/Offers Viewed.svg";
import AwardedPromotions from "../../../assets/img/Awarded Promotions.svg";
import PerformanceSummaryIcon from "../../../assets/img/Performance Summary.svg";
import CampaignActions from "../../../assets/img/Campaign Actions.svg";
import EditCampaign from "../../../assets/img/Edit Campaign.svg";
import ViewAnalytics from "../../../assets/img/View Analytics.svg";
import CampaignSettings from "../../../assets/img/Campaign Settings.svg";
import AnalyticsDashboard from "../../../assets/img/Analytics Dashboard.svg";
import CreateNewCampaign from "../../../assets/img/Create New Campaign.svg";
import bestPractices from "../../../assets/img/best Practices.svg";
import CalendarIcon from "../../../assets/img/ci_calendar.svg";
import lucide_edit from "../../../assets/img/lucide_edit.svg";
import fluent_delete from "../../../assets/img/fluent_delete-12-regular.svg";
import basil_eye from "../../../assets/img/basil_eye-outline.svg";
import { useGlobalState } from "../../../Providers/GlobalStateProvider";

const getCampaignStatusMeta = (status) => {
  if (status === 1) {
    return { label: "Active", className: "status-active" };
  }
  if (status === 2) {
    return { label: "Paused", className: "status-paused" };
  }
  return { label: "Completed", className: "status-completed" };
};

const PromotionListing = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setGlobalLoading } = useGlobalState();
  const [loading, setLoading] = useState(true);

  const [promotionData, setPromotionData] = useState([]);
  const [servicesData, setServicesData] = useState([]);
  const [selectedPromotionId, setSelectedPromotionId] = useState(null);
  const [showDeletePromotionModal, setShowDeletePromotionModal] =
    useState(false);
  const [counts, setCounts] = useState({
    activeCount: 0,
    otherCounts: [
      { totalViewCount: 0, totalAwardedCount: 0, totalCreditSpents: 0 },
    ],
  });

  useEffect(() => {
    if (!localStorage.getItem("professionalToken")) {
      navigate("/professional/login");
    } else {
      setGlobalLoading(true);
      dispatch(hitGetServiceProfessionalApi());
      dispatch(hitPromotionListProfessionalApi()); // Initial fetch with default params
    }
  }, []);

  // Redux state
  const responsePromotionListProfessional = useSelector(
    (state) => state.promotionListProfessionalReducer.data
  );

  useEffect(() => {
    //console.log("Promotion List Response:", responsePromotionListProfessional);
    if (responsePromotionListProfessional?.status === true) {
      setLoading(false);
      setGlobalLoading(false);
      setPromotionData(responsePromotionListProfessional.data);
      setCounts(responsePromotionListProfessional.counts || {});
    }
  }, [responsePromotionListProfessional]);

  const responseServicesData = useSelector(
    (state) => state.getServiceProfessionalReducer.data
  );
  useEffect(() => {
    if (responseServicesData?.status === true) {
      setServicesData(responseServicesData?.data || []);
    }
  }, [responseServicesData]);

  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("All Status");
  const [categoryFilter, setCategoryFilter] = useState("All Categories");
  const [sortBy, setSortBy] = useState("Newest First");

  const handleCreateCampaign = () => {
    handleViewDetailsTop();
    navigate("/professional/add-campaign");
  };

  const handleViewDetails = (campaignId) => {
    handleViewDetailsTop();
    navigate("/professional/view-campaign", {
      state: { campaignId },
    });
  };

  const handleEdit = (campaignId) => {
    navigate(`/campaign/edit/${campaignId}`);
  };

  const handleDelete = () => {
    // Dispatching the delete API call
    setLoading(true);
    setGlobalLoading(true);
    dispatch(
      hitPromotionUpdateApi({ promotionId: selectedPromotionId, isDeleted: 1 })
    )
      .then((response) => {
        setLoading(false);
        setGlobalLoading(false);
        if (response?.payload?.status === true) {
          setShowDeletePromotionModal(false);
          showToast(response.payload.message, "success");
          dispatch(hitPromotionListProfessionalApi());
        } else {
          setLoading(false);
          setGlobalLoading(false);
          showToast(response.error.message, "error");
        }
      })
      .catch((error) => {
        setLoading(false);
        setGlobalLoading(false);
        // Optionally handle any errors that happen during the dispatch
        console.error("Error in deletion:", error);
        showToast("There was an error processing your request.", "error");
      });
  };

  //🔄 Call API whenever any filter or search changes
  useEffect(() => {
    setLoading(true);
    setGlobalLoading(true);
    const delayDebounce = setTimeout(() => {
      let searchParams = {
        sortOrder: -1,
        sortBy:
          sortBy == 1
            ? "_id"
            : sortBy == 2
              ? "_id"
              : sortBy == 3
                ? "viewCount"
                : sortBy == 4
                  ? "conversionCount"
                  : "_id",
      };
      if (categoryFilter !== "0" && categoryFilter !== "All Categories") {
        searchParams.serviceId = categoryFilter;
      }
      if (sortBy == 2) {
        searchParams.sortOrder = 1;
      }
      if (statusFilter !== "0" && statusFilter !== "All Status") {
        searchParams.status = statusFilter;
      }
      if (searchQuery !== "") {
        searchParams.search = searchQuery;
      }
      //console.log("Search Params:", searchParams);
      dispatch(hitPromotionListProfessionalApi(searchParams))
        .then(() => {
          setLoading(false);
          setGlobalLoading(false);
        }) // ✅ stop loading after success
        .catch(() => {
          setLoading(false);
          setGlobalLoading(false);
        }); // ❌ stop loading even on failure
    }, 400);
    return () => clearTimeout(delayDebounce);
  }, [searchQuery, statusFilter, categoryFilter, sortBy]);

  const handleViewDetailsTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const isSearchFilterActive = searchQuery.trim().length > 0;
  const isStatusFilterActive =
    statusFilter !== "0" && statusFilter !== "All Status";
  const isCategoryFilterActive =
    categoryFilter !== "0" && categoryFilter !== "All Categories";

  if (loading) {
    return <div style={{ height: "100vh" }}><Loader /></div>;
  }

  return (
    <div className="promotion-listing pro-app-page">
      <div className="custom_container">
        {/* Main Content Row */}
        <Row>
          <Col xl={8}>
            <Row>
              {/* Header Section */}
              <div className="header-section">
                <div className="header-content">
                  <h1>Promotional Campaigns</h1>
                  <p>
                    Manage and optimize your marketing campaigns to attract more
                    customers
                  </p>
                </div>
                <button
                  className="create-campaign-btn"
                  onClick={() => handleCreateCampaign()}
                >
                  <FaPlus /> Create New Campaign
                </button>
              </div>
              {/* Stats Cards */}
              <div className="stats-cards-wrapper">
                <div className="stat-card blue blue-border-bg">
                  <div className="stat-icon">
                    <img src={ActiveCampaigns} alt="Active Campaigns" />
                  </div>
                  <div className="stat-info">
                    <h3 style={{ color: "#2463EB" }}>
                      {counts && counts.activeCount}
                    </h3>
                    <p style={{ color: "#2463EB" }}>Active Campaigns</p>
                  </div>
                </div>
                <div className="stat-card green green-border-bg">
                  <div className="stat-icon">
                    <img src={OffersViewed} alt="Claims Viewed" />
                  </div>
                  <div className="stat-info">
                    <h3 style={{ color: "#328756" }}>
                      {counts && counts?.claimedCount}
                    </h3>
                    <p style={{ color: "#328756" }}>Claims Viewed</p>
                  </div>
                </div>
                <div className="stat-card purple purple-border-bg">
                  <div className="stat-icon">
                    <img src={AwardedPromotions} alt="Awarded Promotions" />
                  </div>
                  <div className="stat-info">
                    <h3>
                      {counts && counts?.awardedCount}
                    </h3>
                    <p>Awarded Promotions</p>
                  </div>
                </div>
              </div>
              {/* Search and Filters */}
              <div className="search-filter-wrapper">
                <div
                  className={`filter-control filter-control--search ${
                    isSearchFilterActive ? "filter-control--active" : ""
                  }`}
                >
                  {isSearchFilterActive && (
                    <span className="filter-active-dot" aria-hidden="true" />
                  )}
                  <div className="search-box">
                    <FaSearch className="search-icon" />
                    <input
                      type="text"
                      placeholder="Search campaigns..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </div>
                </div>
                <div
                  className={`filter-control filter-control--select ${
                    isStatusFilterActive ? "filter-control--active" : ""
                  }`}
                >
                  {isStatusFilterActive && (
                    <span className="filter-active-dot" aria-hidden="true" />
                  )}
                  <select
                    value={statusFilter}
                    onChange={(e) => setStatusFilter(e.target.value)}
                    className="filter-select"
                  >
                    <option value="0">All Status</option>
                    <option value="1">Active</option>
                    <option value="2">Paused</option>
                    <option value="3">Completed</option>
                  </select>
                </div>
                <div
                  className={`filter-control filter-control--select ${
                    isCategoryFilterActive ? "filter-control--active" : ""
                  }`}
                >
                  {isCategoryFilterActive && (
                    <span className="filter-active-dot" aria-hidden="true" />
                  )}
                  <select
                    value={categoryFilter}
                    onChange={(e) => setCategoryFilter(e.target.value)}
                    className="filter-select"
                  >
                    <option value="0">All Categories</option>
                    {servicesData &&
                      servicesData.map((category) => (
                        <option key={category._id} value={category._id}>
                          {category.name}
                        </option>
                      ))}
                  </select>
                </div>
                {/* <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="filter-select"
                >
                  <option value="1">Newest First</option>
                  <option value="2">Oldest First</option>
                  <option value="3">Most Views</option>
                  <option value="4">Most Conversions</option>
                </select> */}
                {/* <button className="search-btn" onClick={() => {
                  searchClick()
                }}>
                  <FaSearch />
                </button> */}
              </div>

              {/* Campaign Cards Grid */}
              <Row className="campaign-cards-grid">
                {promotionData && promotionData.length > 0 ? (
                  promotionData.map((campaign) => {
                    const statusMeta = getCampaignStatusMeta(campaign.status);

                    return (
                    <Col xl={6} key={campaign._id}>
                      <div className="campaign-card">
                        <div className="campaign-image-wrapper">
                          <img
                            src={campaign.media[0]}
                            alt={campaign.title}
                            className="campaign-image"
                          />
                          {campaign?.discountType !== null && (
                            <span className="discount-badge">
                              {campaign?.discountType === 1
                                ? "$" + campaign?.discountValue + " off / sq ft"
                                : campaign?.discountType === 2
                                  ? campaign?.discountValue + "% off"
                                  : "$" + campaign?.discountValue + " off"}
                            </span>
                          )}
                          <div className={`status-badge ${statusMeta.className}`}>
                            {campaign.status !== 2 && (
                              <span className="status-dot"></span>
                            )}{" "}
                            {statusMeta.label}
                          </div>
                        </div>

                        <div className="campaign-content">
                          <h3 className="campaign-title">
                            {campaign.promotionTitle}
                          </h3>
                          <span className="category-label">
                            {campaign.serviceIds.name}
                          </span>

                          <p className="campaign-description">
                            {campaign.promotionDetails}
                          </p>

                          <div className={`status-tag ${statusMeta.className}`}>
                            {campaign.status === 1 && (
                              <span className="status-icon">
                                <img src={tick} alt="tick" className="me-1" />
                              </span>
                            )}{" "}
                            {statusMeta.label}
                          </div>
                          <br />

                          <span className="category-badge">
                            {campaign.category}
                          </span>

                          <div className="campaign-stats-grid">
                            <div>
                              <div className="stat-box">
                                <div
                                  className="stat-value text-center"
                                  style={{ color: "#2563eb" }}
                                >
                                  {campaign.viewCount}
                                </div>
                                <div className="stat-label text-center">
                                  Views
                                </div>
                              </div>
                              <div className="stat-box">
                                <div
                                  className="stat-value text-center"
                                  style={{ color: "#a04cec" }}
                                >
                                  {campaign.leadCount}
                                </div>
                                <div className="stat-label text-center">
                                  Leads
                                </div>
                              </div>
                            </div>
                            <div>
                              <div className="stat-box">
                                <div
                                  className="stat-value text-center"
                                  style={{ color: "#318555" }}
                                >
                                  {campaign.conversionCount}
                                </div>
                                <div className="stat-label text-center">
                                  Conversions
                                </div>
                              </div>
                              <div className="stat-box credits text-center">
                                <div
                                  className="stat-value credits-text"
                                  style={{ color: "#b1302f" }}
                                >
                                  {campaign.totalCreditSpent} credits
                                </div>
                                <div className="stat-label">Spent</div>
                              </div>
                            </div>
                          </div>

                          <div className="date-range">
                            <img src={CalendarIcon} alt="Calendar" />{" "}
                            {moment(campaign.createdAt).format("MM/DD/YYYY")} -{" "}
                            {moment(campaign.endDate).format("MM/DD/YYYY")}
                          </div>

                          <div className="three_btn_details">
                            <div className="action-buttons">
                              <button
                                className="edit-btn"
                                onClick={() => {
                                  handleViewDetailsTop();
                                  navigate(`/professional/edit-campaign`, {
                                    state: { campaignId: campaign._id },
                                  });
                                }}
                              >
                                <img src={lucide_edit} alt="lucide_edit" /> Edit
                              </button>
                              <button
                                className="delete-btn"
                                onClick={() => {
                                  setShowDeletePromotionModal(true);
                                  setSelectedPromotionId(campaign._id);
                                }}
                              >
                                <img
                                  src={fluent_delete}
                                  alt="fluent_delete-12-regular"
                                />{" "}
                                Delete
                              </button>
                            </div>

                            <button
                              className="view-details-btn"
                              onClick={() => handleViewDetails(campaign._id)}
                            >
                              <img
                                src={basil_eye}
                                alt="basil_eye-outline"
                                style={{ marginTop: 4 }}
                              />{" "}
                              View Details
                            </button>
                          </div>
                        </div>
                      </div>
                    </Col>
                    );
                  })
                ) : (
                  // set to center
                  <div className="no-data" style={{ textAlign: "center" }}>
                    No campaigns found.
                  </div>
                )}
              </Row>
            </Row>
          </Col>

          {/* Sidebar */}
          <Col xl={4}>
            <div className="sidebar-wrapper">
              {/* Performance Summary - Single Card */}

              {/* Campaign Actions - Updated Design */}

              {/* Quick Actions */}
              <div className="sidebar-card">
                <h4>Quick Actions</h4>
                <button
                  className="quick-btn red"
                  onClick={() => {
                    handleViewDetailsTop();
                    navigate("/professional/add-campaign");
                  }}
                >
                  <img src={CreateNewCampaign} alt="Create New Campaign" />
                  <div className="btn-text">
                    <strong>Create New Campaign</strong>
                    <small>Launch new promotional campaign</small>
                  </div>
                </button>
                {/* <button className="quick-btn blue">
                  <img src={AnalyticsDashboard} alt="Analytics Dashboard" />
                  <div className="btn-text">
                    <strong>Analytics Dashboard</strong>
                    <small>View detailed performance metrics</small>
                  </div>
                </button>
                <button className="quick-btn green">
                  <img src={CampaignSettings} alt="Campaign Settings" />
                  <div className="btn-text">
                    <strong>Campaign Settings</strong>
                    <small>Manage default campaign settings</small>
                  </div>
                </button> */}
              </div>

              {/* Campaign Best Practices */}
              <div className="sidebar-card best-practices-card">
                <div className="card-header">
                  <div className="icon-wrapper green">
                    <img src={bestPractices} alt="Best Practices" />
                  </div>
                  <h4>Campaign Best Practices</h4>
                </div>
                <div className="best-practices-list">
                  <div className="practice-item">
                    <h5>High-Quality Images</h5>
                    <p>Use professional photos to increase engagement by 40%</p>
                  </div>
                  <div className="practice-item">
                    <h5>Clear Value Proposition</h5>
                    <p>Highlight specific benefits and savings clearly</p>
                  </div>
                  <div className="practice-item">
                    <h5>Optimal Duration</h5>
                    <p>14-30 day campaigns typically perform best</p>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
      {showDeletePromotionModal && (
        <div className="modal-overlay">
          <div className="withdraw-modal">
            <div className="withdraw-icon">⚠️</div>
            <p className="withdraw-message">
              Campaign Delete?
              <br />
              Are you sure you want to delete the campaign?
            </p>
            <div className="modal-actions">
              <button className="confirm-btn" onClick={() => handleDelete()}>
                Confirm
              </button>
              <button
                className="cancel-btn"
                onClick={() => setShowDeletePromotionModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PromotionListing;
